export class CommonUtil {
  static sleep = async (ms: number): Promise<unknown> => new Promise((resolve) => setTimeout(resolve, ms));
}
